/* ------------------------------------------------------------------
   File: Newsroom.jsx
   Author: Engr. Shaffa K. Kokro Jr. - CEO, Accend Holdings Ltd.
   Last Modified: 2026-05-10
------------------------------------------------------------------ */

import React from 'react'

function Newsroom() {
  return (
    <div>
      Newsroom Page
    </div>
  )
}

export default Newsroom
